/**
 * An Enum of all available apps on the system
 */
const Apps = {
    ManagerInfoPage: 'manager-info-page',
    Profile: 'profile',
    Security: 'security',
    Invoice: 'invoice',
    Calendar: 'calendar',
    Notifications: 'notifications',
    ImportExport: 'import-export',
    AddonServices: 'addon-services',
    Api: 'api',
    AutomaticCleanup: 'automatic-cleanup',
    Billy: 'billy',
    BookingStatus: 'booking-status',
    ClientLogin: 'client-login',
    Consent: 'consent',
    CustomClientFields: 'custom-client-fields',
    Danmark: 'danmark',
    Dinero: 'dinero',
    DiscountCodes: 'discount-codes',
    Ean: 'ean',
    EasyPay: 'easy-pay',
    Economic: 'economic',
    Events: 'events',
    FacebookClientLogin: 'facebook-client-login',
    Fiken: 'fiken',
    Giftcards: 'giftcards',
    GoogleAnalytics: 'google-analytics',
    GoogleCalendar: 'google-calendar',
    Journal: 'journal',
    Mailchimp: 'mailchimp',
    OnlineBooking: 'online-booking',
    OnlineMeetings: 'online-meetings',
    PaymentRates: 'payment-rates',
    Reports: 'reports',
    SecureMessages: 'messaging',
    Surveys: 'surveys',
    ClientTags: 'client-tags',
    TranslationBeta: 'translation-beta',
    TwoFactorAuth: 'two-factor-auth',
    UserManagement: 'user-management',
    Vouchers: 'vouchers',
    WaitingList: 'waiting-list',
    Zapier: 'zapier',
    Medcom: 'medcom',
    OnlineCourses: 'online-courses',
    Mobilepay: 'mobilepay',
    Zettle: 'zettle',
    Ehf: 'ehf',
    Fortnox: 'fortnox',
    OtherPayers: 'other-payers',
    MitID: 'mit-id',
    BehandlerBooking: 'behandler-booking',
    BankID: 'bank-id',
    BirthdayNotificationsApp: 'birthday-notifications',
    ResourceManagement: 'resource-management',
    Memberships: 'memberships',
    Tenants: 'tenants',
    Helsenett: 'helsenett',
    Diagnosis: 'diagnosis',
    Documents: 'documents',
    ClientGroups: 'client-groups',
    Sms: 'sms',
    HelfoSettlements: 'helfo-settlements',
    Exorlive: 'exorlive',
    Vipps: 'vipps',
    Treatments: 'treatments',
    Digicare: 'digicare',
    GeneralPractitioner: 'general-practitioner',
    Sales: 'sales',
    KidOcrSupport: 'kid-ocr-support',
    Accounting: 'accounting',
    BookingPortal: 'booking-portal',
    Tasks: 'tasks',
    PatientTravel: 'patient-travel',
    TeamMeetings: 'team-meetings',
    PersonService: 'person-service',
    Kanta: 'kanta',
    AiAssistant: 'ai-assistant',
    NorwegianPatientRegistry: 'norwegian-patient-registry',
    Medipay: 'medipay',
    TripleTex: 'triple-tex',
    Convene: 'convene',
//--- New App Enum ---// <--- DO NOT REMOVE THIS LINE
}

export default Apps;
